import "./CheckoutRegister.css";
import { createSearchParams, useNavigate, useParams, useSearchParams } from "react-router-dom";
import HeaderController from "../../components/Headers/HeaderController";
import * as translator from "../../utils/translator";
import RegistrationForm from "../../components/RegistrationForm/RegistrationForm";
import * as http from "../../utils/http";
import { useEffect, useState } from "react";
import OrderWindow from "../../components/OrderWindow/OrderWindow";
import LoginModal from "../../components/Modals/LoginModal/LoginModal";
import StickyNotification from "../../components/StickyNotification/StickyNotification";
import { clientConfig } from "../../config";
import LoadingModal from "../../components/Modals/LoadingModal/LoadingModal";
import ServerError from "../../components/ServerError/ServerError";
import { MainTracker } from "../../PixelTrackers/MainTracker";
import ForgotPasswordModal from "../../components/Modals/ForgotPasswordModal/ForgotPasswordModal";
import Footer from "../../components/Footer/Footer";
import { useCartContext } from "../../customHooks/useCart";
import CartViewDE from "../../components/CartViewDE";
import CartView from "../../components/CartView";
import { shouldShowPriceBreakdown } from "../../utils/helpers";
import { CLICK_EXPAND_PRODUCTS } from "../../utils/consts";
import { useRef } from "react";
import { buildRedirectSearch } from "./redirectSearch";
import { SERVICE_OPTIONS } from "../../utils/consts";
import { useAppContext } from "../../providers/AppProvider";
import { loadCustomerFromSession } from "../../customHooks/useCustomer";


import { isPostCheckoutVerificationCountry } from "../../utils/postCheckoutVerification";
import RegistrationV3 from "../v3/RegistrationV3/RegistrationV3";
import CarePlusShippingCartCard from "../CarePlusShared/CarePlusShippingCartCard";
import CarePlusCostBreakdown from "../CarePlusShared/CarePlusCostBreakdown";
import { getCarePlusCostBreakdownRows } from "../CarePlusShared/carePlusCostBreakdownRows";
import { getCarePlusCostBreakdownInput } from "../CarePlusShared/carePlusCostBreakdownInput";
import { getCarePlusShippingCartProps } from "../CarePlusShared/carePlusShippingCartProps";
import { lineFromProducts } from "../ChoosePlanCarePlus/useChoosePlanCarePlus";

export default function CheckoutRegister() {
  const navigate = useNavigate();
  const { country, language } = useParams();
  const [searchParams] = useSearchParams();
  // GB/CH skip pre-purchase Jumio; ID + photo happen post-purchase in My Account.
  const isPostCheckoutCountry = isPostCheckoutVerificationCountry(country);
  const { getCart, saveCart, setCartCurrency, cartCurrency } = useCartContext();
  const { setHeaderVersion } = useAppContext();
  const cart = getCart();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [checkoutLoaded, setCheckoutLoaded] = useState(false);
  const [showForgotPasswordModal, setShowForgotPassword] = useState(false);
  const [orderWindowDetails, setOrderWindowDetails] = useState({});
  const [isCannabisCatalog, setIsCannabisCatalog] = useState(false);
  const [productsGroupedByPharmacy, setProductsGroupedByPharmacy] = useState([]);
  const [stickyNotificationDetails, setStickyNotificationDetails] = useState({ // global state for sticky handling
    show: false,
    title: "",
    content: "",
    level: "",
    showInfoIcon: true,
    refresh: false,
  });
  const zipCode = searchParams.get("zipcode");
  // HL-11357: a Care+ one-time / prescription-only order has no plan fee for ShippingV2 to key
  // off of, so ChoosePlanCarePlus marks it with care_plus=1 before handing the guest here.
  // Registration is a hop in the middle of that funnel, so the marker has to survive it --
  // otherwise Shipping renders the default layout instead of the Care+ one.
  const carePlusMarker = searchParams.get("care_plus");
  const customerVerificationType = cart?.customer_verification_type;
  const [registrationV3Enabled, setRegistrationV3Enabled] = useState(false);
  const isV3LoggedIn = registrationV3Enabled && Boolean(loadCustomerFromSession());

  // routes to the next page
  const vcRedirectTemplate = `/choose-doctor/${country}/${language}/:mention`;
  const shippingRedirectPath = `/shipping/${country}/${language}`;
  const customerVerificationRedirectPath = `/customer-verification/${country}/${language}`;
  const selectTreatmentRedirectTemplate = `/select_treatment/${country}/${language}/:mention`;


  // User click breakdown tracking (using refs to avoid closure issues)
  const openedTooltipsRef = useRef(new Set());
  const userClicksRef = useRef(new Set());
  const isExpressSelected = cart.selected_service_option === SERVICE_OPTIONS.EXPRESS;

  // redirect path for the user - can move to a util function
  const getRedirectRoute = (conditions, data) => {
    const { exceededCategoryLimit, shouldIDVerify, consultationType } = conditions;
    const { mention= cart.mention } = data;
    // WARNING: keep this order!!!

    if (exceededCategoryLimit) {
      // limit_disclaimer query param should be added to the url
      return selectTreatmentRedirectTemplate.replace(":mention", mention);
    }

    if (shouldIDVerify && !isPostCheckoutCountry) {
      return customerVerificationRedirectPath;
    }

    if (consultationType === "video") {
      return vcRedirectTemplate.replace(":mention", mention);
    }
    
    return shippingRedirectPath;
  }



  const successNavigationCallback = (conditions, data = {}, extraParams = {}) => {
    const pathname = getRedirectRoute(conditions, data);
    const search = buildRedirectSearch(extraParams, {
      deeplinkCoupon: window.eventsTracking.getData("cpn"),
      zipCode,
      carePlusMarker,
    });

    navigate(
      { pathname, search: createSearchParams(search).toString() },
      { replace: true }
    );
  };




  // for social login, we don't need the verification redirect, the callback will handle this
  const socialLoginBasePath = cart?.consultation_type === "video"
    ? `${vcRedirectTemplate.replace(":mention", cart.mention)}`
    : shippingRedirectPath;
  const socialLoginredirectPath = carePlusMarker
    ? `${socialLoginBasePath}?care_plus=${carePlusMarker}`
    : socialLoginBasePath;


  
  // Redirect logged-in users (they shouldn't be on the sign_up page)
  useEffect(() => {
    const customerFromSession = loadCustomerFromSession();
    if (!checkoutLoaded || !customerFromSession || !cart.id) {
      return;
    }

    // V3 goes straight to Shipping; ID verification and video consult redirects stay on the legacy flow.
    successNavigationCallback(
      registrationV3Enabled ? {} : { shouldIDVerify: cart?.should_id_verify, consultationType: cart?.consultation_type },
    );
  }, [cart, checkoutLoaded, registrationV3Enabled]);

  //this part is for adding the otc
  let request;
  useEffect(() => {
      const cpn = searchParams.get("cpn");
      const url = `checkout_register/${country}/${language}` + (cpn ? `?cpn=${cpn}` : '');
      request = http.getFromServer(url, [http.MIDDLEWARES.CART_ORDER])
        request.then((response) => {
        if (response.data.cartCurrency) {
          setCartCurrency(response.data.cartCurrency)
        }
        setIsCannabisCatalog(response.data.isCannabisCatalog);
        setProductsGroupedByPharmacy(response.data.productsGroupedByPharmacy || []);
        // Set headerVersion based on isCannabisCatalog
        if (response.data.isCannabisCatalog) {
          setHeaderVersion('v2');
        } else {
          setHeaderVersion('v1');
        }
        const responseCart = response.data.cart
        // WL Care+ layout: always the V3 sign-up (V3 won the weight_loss_v3 test). Elsewhere the catalog setting decides.
        setRegistrationV3Enabled(response.data.isCarePlusLayout === true || response.data.registrationV3Enabled === true);
        //New multiple rx funnel flow
        if (["funnel_new_multiple", "shipping_multiple_premium"].includes(responseCart.funnel_version)) {
          saveCart({
            ...responseCart,
            products: response.data.products,
            timekitBooking: response.data.timekitBooking,
          });

        //Backwards compatibility
        } else {
          setOrderWindowDetails({
            itemImageUrl: clientConfig.IMAGES_URL + response.data.productFeatures.imageSuffix,
            itemTitle: response.data.productFeatures.title,
            itemQuantity: response.data.productFeatures.quantity,
            treatmentFee: Number(responseCart.treatment_fee),
            Price: Number(responseCart.item_price),
            serviceFee: response.data.productFeatures.service_fee,
            isSubsidized: response.data.productFeatures.is_subsidized,
            subscriptionDiscount: responseCart.applied_subscription_discount,
            autoBonusValue: Number(responseCart.auto_bonus) === 1 ? Number(responseCart.bonus_value) : 0,
            prescriptionOnlyFlow: responseCart.allow_only_prescription && !responseCart.product_in_stock,
            isSelfPickup: responseCart.self_pickup_pharmacy_id ? true : false
          });
        }

        setCheckoutLoaded(true);
        MainTracker.superProperties({ "Treatment fee": responseCart.treatment_fee });
        setLoading(false);
      })
      .catch((err) => {
        if (err.response?.data?.logLevel === "warn") {
          window.clientLogger.warn("error get data from server checkout register", err)
        }
        else {
          window.clientLogger.error("error get data from server checkout register", err)
        }

        setError(500);
        setLoading(false);
      });

  }, []);

  const carePlusT = (key, fallback) => translator.translate(language, "choose_plan_care_plus", key) || fallback;
  const currencyLocale = cartCurrency?.locale ?? "de-DE";
  const currencyRate = cartCurrency?.rate ?? 1;

  const renderCarePlusCard = (carePlusCart, extraProps) => <CarePlusShippingCartCard
    {...carePlusCart.cardProps}
    t={carePlusT}
    medication={cart.only_prescription ? null : lineFromProducts(cart.products ?? [])}
    currencyLocale={currencyLocale}
    currencyRate={currencyRate}
    {...extraProps}
  />;

  // The V3 layout has no slot for the legacy cart views, so non-Care+ carts get none.
  const renderV3CartSummary = () => {
    const carePlusCart = getCarePlusShippingCartProps(cart, carePlusMarker === "1");
    if (!carePlusCart.isCarePlusOrder) return null;
    return <>
      {renderCarePlusCard(carePlusCart, { fullTierName: true })}
      <CarePlusCostBreakdown
        t={carePlusT}
        rows={getCarePlusCostBreakdownRows({ t: carePlusT, ...getCarePlusCostBreakdownInput(cart) })}
        currencyLocale={currencyLocale}
        currencyRate={currencyRate}
        onToggle={(isOpen) => MainTracker.track("custom", "Click Cost Details", {
          page: "Sign up",
          state: isOpen ? "open" : "close",
        })}
      />
    </>;
  };

  const renderCartSummary = (className, summaryAfterProducts = false, hideCostDetails = false) => {
    const carePlusCart = getCarePlusShippingCartProps(cart, carePlusMarker === "1");
    if (carePlusCart.isCarePlusOrder) {
      return renderCarePlusCard(carePlusCart, { hideNextMonthDetails: true, compact: true });
    }

    if (["funnel_new_multiple", "shipping_multiple_premium"].includes(cart?.funnel_version)) {
      if (shouldShowPriceBreakdown(country, cart?.products, { isSubsidized: orderWindowDetails.isSubsidized })) {
        return <CartViewDE
          hideSubscriptionPlans
          showProductsQuantityControl={false}
          isCannabisCatalog={isCannabisCatalog}
          isExpressShipping={isExpressSelected}
          productsGroupedByPharmacy={productsGroupedByPharmacy}
          summaryAfterProducts={summaryAfterProducts}
          hideCostDetails={hideCostDetails}
          className={className}
          OTCAddonsTrigger={<></>}
          onExpandProducts={() => {
            userClicksRef.current.add(CLICK_EXPAND_PRODUCTS);
          }}
          onTooltipOpen={(tooltipId) => {
            openedTooltipsRef.current.add(tooltipId);
          }}
        />;
      }

      return <CartView
        hideSubscriptionPlans
        showProductsQuantityControl={false}
        className={className}
      />;
    }

    return <OrderWindow
      shippingFee={0}
      itemImageUrl={orderWindowDetails.itemImageUrl}
      itemTitle={orderWindowDetails.itemTitle}
      Price={orderWindowDetails.Price}
      serviceFee={orderWindowDetails.serviceFee}
      isSubsidized={orderWindowDetails.isSubsidized}
      itemQuantity={orderWindowDetails.itemQuantity}
      treatmentFee={orderWindowDetails.treatmentFee}
      subscriptionDiscount={orderWindowDetails.subscriptionDiscount}
      autoBonusValue={orderWindowDetails.autoBonusValue}
      prescriptionOnlyFlow={orderWindowDetails.prescriptionOnlyFlow}
    />;
  };

  return (
    <>
      {loading && <LoadingModal />}

      {error && (
        <>
          <HeaderController showSteps={false} stage={"Questionnaire"} />
          <ServerError status={error} />
        </>
      )}

      {!error && !loading && (
        registrationV3Enabled ? (
          !isV3LoggedIn && (
            <div className="checkout-register-v3">
              <StickyNotification
                showNotification={stickyNotificationDetails.show}
                title={stickyNotificationDetails.title}
                onClick={() => setStickyNotificationDetails((currentDetails) => { return { ...currentDetails, show: false } })}
                content={stickyNotificationDetails.content}
                level={stickyNotificationDetails.level}
                showInfoIcon={stickyNotificationDetails.showInfoIcon}
                refresh={stickyNotificationDetails.refresh}
              />
              <RegistrationV3
                country={country}
                language={language}
                redirectPath={socialLoginredirectPath}
                cameFromPath={`sign_up/${country}/${language}${zipCode ? `?zipcode=${zipCode}` : ''}`}
                customerVerificationType={customerVerificationType}
                cartSummary={renderV3CartSummary()}
                setStickyNotificationDetails={setStickyNotificationDetails}
                onAuthenticated={() => {
                  successNavigationCallback({ shouldIDVerify: cart?.should_id_verify, consultationType: cart?.consultation_type });
                }}
              />
            </div>
          )
        ) : (
        <>
          <StickyNotification
            showNotification={stickyNotificationDetails.show}
            title={stickyNotificationDetails.title}
            onClick={() => setStickyNotificationDetails((currentDetails) => { return { ...currentDetails, show: false } })}
            content={stickyNotificationDetails.content}
            level={stickyNotificationDetails.level}
            showInfoIcon={stickyNotificationDetails.showInfoIcon}
            refresh={stickyNotificationDetails.refresh}
          />

          {showLoginModal && (
            <LoginModal
              setStickyNotificationDetails={setStickyNotificationDetails}
              closeModal={() => setShowLoginModal((current) => !current)}
              navigationCallback={(exceededCategoryLimit, mention, shouldIDVerify) => {
                const navigationConditions = {
                  shouldIDVerify: shouldIDVerify,
                  consultationType: cart.consultation_type,
                  exceededCategoryLimit
                }
                const navigationData = {
                  mention
                };

                const navigationOptions = {
                  ...(exceededCategoryLimit && { limit_disclaimer: true })
                }

                successNavigationCallback(navigationConditions, navigationData, navigationOptions);
                
              }}
              showForgotPassword={showForgotPasswordModal}
              changeShowForgotPassword={(boolValue) => { setShowForgotPassword(boolValue) }}
              language={language}
              country={country}
              redirectPath={socialLoginredirectPath}
              customerVerificationType={customerVerificationType}
              cameFromPath={`sign_up/${country}/${language}?zipcode=${zipCode}`}
            />
          )}

          {showForgotPasswordModal && (
            <ForgotPasswordModal
              closeModal={() => setShowForgotPassword(false)}
              language={language}
              setStickyNotificationDetails={setStickyNotificationDetails}
            />
          )}

          <HeaderController language={language} stage="SignUp" />
          <div className="checkout-register-body checkout-register-legacy">
            <div className="checkout-register-container">
              <div className="orderWindow-container-upper">
                {renderCartSummary()}
              </div>


              <div className="checkout-register-headers">
                <p className="checkout-register-mainTitle">
                  {translator.translate(
                    language,
                    "default",
                    "RegistrationForm/title"
                  )}
                </p>
                <span
                  onClick={() => setShowLoginModal((current) => !current)}
                  className="checkout-register-loginTitle"
                >
                  {translator.translate(
                    language,
                    "default",
                    "RegistrationForm/login_title"
                  )}{" "}
                  <span className="checkout-register-loginTitle-loginhere">
                    {" "}
                    {translator.translate(
                      language,
                      "default",
                      "RegistrationForm/login_here"
                    )}{" "}
                  </span>
                </span>
              </div>

              <div className="checkout-register-form-and-order-container">
                <RegistrationForm
                    navigationCallback={() =>{
                      successNavigationCallback({ shouldIDVerify: cart?.should_id_verify, consultationType: cart?.consultation_type });
                    }}
                    setStickyNotificationDetails={setStickyNotificationDetails}
                    submitButtonPlaceholder={translator.translate(
                      language,
                      "default",
                      "RegistrationForm/submit_button_text"
                    )}
                    redirectPath={socialLoginredirectPath}
                    customerVerificationType={customerVerificationType}
                    cameFromPath={`sign_up/${country}/${language}${zipCode ? `?zipcode=${zipCode}` : ''}`}
                    openedTooltipsRef={openedTooltipsRef}
                    userClicksRef={userClicksRef}
                    isCannabisCatalog={isCannabisCatalog}
                  />

                <div className="orderWindow-container-bottom">
                  {renderCartSummary("max-lg:hidden lg:w-[400px]")}
                </div>
              </div>
            </div>
          </div>
          <Footer page="CheckoutRegister" language={language} />
        </>
        )
      )}
    </>
  );
}
